import CommonFilters from '@/shared/models/CommonFilters';
import { BookingSearchCriteria } from '../client/BookingClient';

export default class BookingFilters {
  constructor(
    readonly common: CommonFilters,
  ) {
  }

  asSearchCriteria(): BookingSearchCriteria {
    return {
      outletIds: this.common.activeOutletIds,
      tagIds: this.common.activeDossierTagIds,
    };
  }
}
